export const BIDI_ISOLATE = Symbol('bidi-isolate');
